import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Auth0Service } from '@lib/auth0';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { environment } from '@env/environment';
import { IdleDialogComponent } from '../idle-dialog/idle-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { DialogService } from '../../services/dialog.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-core-layout',
  templateUrl: './core-layout.component.html',
  styleUrls: ['./core-layout.component.scss']
})
export class CoreLayoutComponent implements OnInit, AfterViewInit {
  @ViewChild(IdleDialogComponent, { static: false }) idleDialog: IdleDialogComponent;
  @ViewChild(ConfirmDialogComponent, { static: false }) confirmDialog: ConfirmDialogComponent;

  constructor(private idle: Idle, private authService: Auth0Service, private dialogService: DialogService, private route: ActivatedRoute) {
    this.watchForSessionTimeOut();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.dialogService.addDialog('confirm-dialog', this.confirmDialog);
  }

  private watchForSessionTimeOut() {
    const timeout = (!Number.isNaN(parseInt(environment.sessionTimeout, 10)) ? parseInt(environment.sessionTimeout, 10) : 5) * 60; // Timeout in seconds
    // timeout = 60;
    this.idle.setIdle(Math.abs(timeout * 0.8));
    this.idle.setTimeout(Math.abs(timeout * 0.2));
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      // this.timedOut = true;
      this.logout();
    });

    this.idle.onIdleStart.subscribe(() => {
      this.openIdleModal(Math.abs(timeout * 0.2));
    });

    this.reset();
  }

  private reset() {
    this.idle.watch();
    // this.timedOut = false;
  }

  private openIdleModal(countDown) {
    const instance = this.idleDialog.show(countDown);
    instance.onLogout.subscribe((event) => {
      this.logout();
    });
  }

  private logout() {
    const uri = '/' + (this.route.snapshot.params.nmls || '');
    this.authService.logout({
      redirectUri: uri
    });
  }
}
